import { terminateEmployeeDependent } from "EntitiesApi/api";
import { takeEvery } from "redux-saga";
import { put } from "redux-saga/effects";

import { REQUEST_TERMINATE_EMPLOYEE_DEPENDENT } from "./actions";

export function* watchRequestTerminateEmployeeDependent(): Generator<any, any, any> {
  yield takeEvery(REQUEST_TERMINATE_EMPLOYEE_DEPENDENT, doRequestTerminateEmployeeDependent);
}

function* doRequestTerminateEmployeeDependent(action): Generator<any, any, any> {
  yield put(terminateEmployeeDependent(action.employeeFormId, action.employeeDependentId));
}
